import React, { useEffect, useState } from 'react';
import { useAuth } from './AuthContext';
import { useNavigate } from 'react-router-dom';
import "./LoginPage.css";
import brainLogo from '../assets/images/brain-logo.png';

const Login: React.FC = () => {
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const { authenticate } = useAuth();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState('login');

  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    birthday: "",
    gender: "male",
    phone: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const handleChange = (e: { target: { name: any; value: any; }; }) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleRegister = async (e: { preventDefault: () => void; }) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    if (formData.password !== formData.confirmPassword) {
      setError("Passwords do not match");
      setLoading(false);
      return;
   }

    try {
        const response = await fetch("https://www.theprojectgenesis.net/api/register", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(formData),
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.message || "Signup failed");
        }

        setCurrentPage('login');
    } catch (error: any) {
        setError(error.message);
    } finally {
        setLoading(false);
    }
};

  const expirationTime = 30 * 60 * 1000; // 30 minutes in milliseconds

  useEffect(() => {
    const savedLoginTime = localStorage.getItem('loginTime');
    if (savedLoginTime) {
      const timeElapsed = Date.now() - parseInt(savedLoginTime, 10);
      if (timeElapsed < expirationTime) {
        // navigate(savedPath); // Redirect to the last visited page or default to "/"
      } else {
        localStorage.removeItem('loginTime');
      }
    }
  }, [navigate]);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    if (email == '' || password == '') {}
    else {
      const auth_result = await authenticate(email, password);
      if (!auth_result.success) {
        setError(auth_result.message || 'Invalid email or password');
      }
    }
  };

  return (
    <div className="login-container">
      <h1 className="title">THE PROJECT GENESIS</h1>
      <p className="subtitle">Innovate. Inspire. Transform.</p>
      {currentPage == 'login' &&
      <div className="logo-container">
        <img
          src={brainLogo}
          alt="Brain Logo"
          className="logo"
        />
      </div>
}
      <p className="welcome-text">
        Welcome to the file store for<br />
        <strong>The FOXX-KELLY HISTORY PROJECT</strong>
      </p>

      {currentPage == 'login' && 
      <form className="login-form" onSubmit={handleLogin}>
        <label className="form-label">
          Enter email & password to access files:
        </label>
        <div className="form-row">
          <input
            type="email"
            id="email"
            className="form-input"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            type="password"
            id="password"
            className="form-input"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          
          <button type="submit" className="submit-button">
            Submit
          </button>
        </div>
        {error && <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>}
        <label className="form-label" style={{marginTop: '20px', fontSize: 'medium'}}>
          If you are a new user, please <a style={{textDecoration: 'underline'}} onClick={() => {
            setCurrentPage('signup')
          }}>register.</a>
        </label>
      </form>
      }
      {currentPage == 'signup' && 
      <div className="signup-container">
      <form className="signup-form" onSubmit={handleRegister}>
        <input type="text" name="first_name" className="signup-input" placeholder="First Name" value={formData.first_name} onChange={handleChange} required />
        <input type="text" name="last_name" className="signup-input" placeholder="Last Name" value={formData.last_name} onChange={handleChange} required />
        <input type="date" name="birthday" className="signup-input" value={formData.birthday} onChange={handleChange} required />
        <select name="gender" className="signup-input" value={formData.gender} onChange={handleChange}>
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="other">Other</option>
        </select>
        <input type="text" name="phone" className="signup-input" placeholder="Phone Number" value={formData.phone} onChange={handleChange} required />
        <input type="email" name="email" className="signup-input" placeholder="Email" value={formData.email} onChange={handleChange} required />
        <input type="password" name="password" className="signup-input" placeholder="Password" value={formData.password} onChange={handleChange} required />
        <input type="password" name="confirmPassword" className="signup-input" placeholder="Confirm Password" value={formData.confirmPassword} onChange={handleChange} required />

        <button type="submit" className="signup-button"  disabled={loading}>
          {loading ? "Signing up..." : "Signup"}
        </button>
        
        
        {error && <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>}
        <label className="form-label" style={{marginTop: '20px', fontSize: 'medium'}}>
          If you already have your account, <a style={{textDecoration: 'underline'}} onClick={() => {
            setCurrentPage('login')
          }}>Log in</a>
        </label>
      </form>
      </div>
      }
    </div>
  );
};

export default Login;
